import { axiosGet, urlGenerator } from "../../../common/Helper/AxiosHelper";
import { TENANT_BASE_URL } from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import { formatDateToLocal } from "../../../common/Helper/Support/DateTimeHelper";
import moment from "moment";
import { HotelFilterMixin } from "./FilterMixin";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";

export default {
    mixins: [HelperMixin, DatatableHelperMixin, HotelFilterMixin],
    data() {
        return {
            urlGenerator,
            options: {
                name: this.$t('floor_assignment'),
                url: `${TENANT_BASE_URL}app/hotel/floor-assignment`,
                showHeader: true,
                tableShadow: false,
                tablePaddingClass: 'pt-primary',
                columns: [
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        key: 'id',
                        isVisible: true
                    },
                    {
                        title: this.$t('work_date'),
                        type: 'custom-html',
                        key: 'work_date',
                        isVisible: true,
                        modifier: (value) => value ? moment(value).format('YYYY-MM-DD') : 'N/A'
                    },
                    {
                        title: this.$t('hotel'),
                        type: 'custom-html',
                        key: 'hotel',
                        isVisible: true,
                        modifier: (value) => value ? value.name : 'N/A'
                    },
                    {
                        title: this.$t('floor'),
                        type: 'text',
                        key: 'floor',
                        isVisible: true,
                    },
                    {
                        title: this.$t('employees'),
                        type: 'component',
                        key: 'employees',
                        isVisible: true,
                        componentName: 'image-group',
                    },
                    {
                        title: this.$t('remark'),
                        type: 'text',
                        key: 'remark',
                        isVisible: true,
                    },
                ],
                filters: [
                    {
                        title: this.$t('hotel'),
                        type: "multi-select-filter",
                        key: "hotels",
                        option: [],
                        listValueField: 'name',
                        permission: !!this.$can('view_hotel_list')
                    },
                    {
                        title: this.$t('floor'),
                        type: "multi-select-filter",
                        key: "floor",
                        option: [],
                        listValueField: 'name',
                        permission: !!this.$can('view_hotel_room')
                    },
                    {
                        title: this.$t('date'),
                        type: "date",
                        key: "date",
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: 'dropdown',
                actions: [
                    {
                        title: this.$t('reassign'),
                        icon: 'repeat',
                        type: 'modal',
                        modifier: row => this.$can('update_hotel_floor_assignment') && row.employee_ids && row.employee_ids.length > 0
                    },
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'modal',
                        modifier: row => this.$can('update_hotel_floor_assignment')
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        url: `${TENANT_BASE_URL}app/hotel/floor-assignment/`,
                        name: 'delete',
                        modifier: row => this.$can('delete_hotel_floor_assignment')
                    }
                ],
            }
        }
    },
    mounted() {
        this.getFilterValues({})
    },
    methods: {
        getFilterValues(value) {
            const roomFilter = this.options.filters.find(item => item.key === 'floor');

            if (value.hotels) {
                axiosGet(`${TENANT_BASE_URL}selectable/hotel/room?hotel_id=${value.hotels}&group=floor&format=floor`)
                    .then(({ data }) => roomFilter.option = data)
                    .catch(error => this.$toastr.e(error.response.data.message))
            } else {
                roomFilter.option = []
            }
        },
    },
}
